module.exports = __webpack_public_path__ + "static/media/white_hand_raising.aa7a86c8.png";